module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Tools/Swiss-knife-ffad662f8c3a3875250edb5cae50a79e.svg";